export const MAX_LOGO_SIZE_BYTES = 512 * 1024; // 512 KB

/**
 * Extract logo URL from settings data. Returns null if empty, missing, or non-string.
 */
export function extractLogo(raw: unknown): string | null {
  return typeof raw === "string" && raw.length > 0 ? raw : null;
}

/**
 * Validate file size for logo upload. Throws if too large.
 */
export function validateLogoFile(file: { size: number }): void {
  if (file.size > MAX_LOGO_SIZE_BYTES) {
    throw new Error(`Logo must be under ${MAX_LOGO_SIZE_BYTES / 1024} KB`);
  }
}
